module.exports = __webpack_public_path__ + "static/media/7.650f04a3.jpg";